import { render } from "./ChatReaction.vue?vue&type=template&id=48e90420"
import script from "./ChatReaction.vue?vue&type=script&lang=js"
export * from "./ChatReaction.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__